import { Component, OnInit } from '@angular/core';
import { IElementsViewModel } from 'src/app/ViewModel/ElementsModel';
import { ElementsService } from 'src/app/Service/elements/elements.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { ElementdetailsService } from 'src/app/Service/elementdetails/elementdetails.service';
import { IElementDetailsViewModel } from 'src/app/ViewModel/ElementDetailsModel';
import { EditElementDetailsComponent } from '../dialogs/elementdetails-dialog/edit-elementdetails-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { CommonService } from 'src/app/Service/Common.service';

@Component({
  selector: 'app-elementdetails',
  templateUrl: './elementdetails.component.html',
  styleUrls: ['./elementdetails.component.css']
})
export class ElementdetailsComponent implements OnInit {

  /**Elements array */
  public elementList: IElementsViewModel[] = [];

  /**Element Details array */
  public elementDetailsList: IElementDetailsViewModel[] = [];

  /**Element Id */
  private elementId!: string | number;

  isDisabled = false;
  memberId!: number;
  enableFilter = false;
  enableFullscreen = false;
  public pageSize = [50, 100, 200, {
    text: 'All',
    value: 'all'
  }];

  constructor(private _elementService: ElementsService, private _notificationService: NotificationService, private _elementDetailsService: ElementdetailsService,
    private _commonService: CommonService, private _dialog: MatDialog,) { }

  ngOnInit() {
    this.memberId = this._commonService.getLoggedInUserId();
    this.getElementsList();
  }

  /**
   * Get Elements list
   */
  getElementsList() {
    this._elementService.GetElementsList().subscribe((data: IElementsViewModel[]) => {
      this.elementList = data.map(x => {
        let result: IElementsViewModel = {
          dE_Id: x.dE_Id, dE_Description: x.dE_Description, is_Active: x.is_Active, user_Id: this.memberId
        };
        return result;
      }).filter(x => x.is_Active == true);
    });
  }

  /**
   * Change Element Value
   * @param selectedElement 
   */
  changeElement(selectedElement: { value: string | number; }) {
    if (selectedElement.value !== '-2') {
      this.elementId = selectedElement.value;
      this.isDisabled = true;
      this.getElementDetailsList(this.elementId);
    }
    else {
      this.isDisabled = false;
    }

  }

  /**
   * Get Element Details List
   * @param elementId 
   */
  getElementDetailsList(elementId: any) {
    this._elementDetailsService.GetElementDetailsList(elementId).subscribe((data: IElementDetailsViewModel[]) => {
      this.elementDetailsList = data.map(x => {
        let result: IElementDetailsViewModel = {
          dE_Id: x.dE_Id,
          deD_Id: x.deD_Id,
          deD_Description: x.deD_Description,
          deD_Short_Description: x.deD_Short_Description,
          deD_CODE: x.deD_CODE,
          is_Active: x.is_Active,
          created_By: x.created_By,
          created_On: x.created_On,
          modified_By: x.modified_By,
          modified_On: x.modified_On,
          userId: this.memberId
        };
        return result;
      });
    });

  }

  /**
   * Add/Update ElementDetails 
   * @param elementdetails ElementDetails model 
   */
  addEditElementDetails(elementdetails: any | IElementDetailsViewModel) {
    if (elementdetails === undefined)
      elementdetails = null;

    const dialogRef = this._dialog.open(EditElementDetailsComponent, {
      panelClass: 'mat-dialog-secondary',
      width: '95%',
      minWidth: '95vw',
      data: { elementdetails: elementdetails, elementId: this.elementId, elementList: this.elementList }
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      let resElementDetails: IElementDetailsViewModel = res.elementdetails;
      if (res.response && res.response.successCode == 200) {
        if (resElementDetails) {
          let filteredOrg: IElementDetailsViewModel = this.elementDetailsList.filter(x => x.dE_Id == resElementDetails.dE_Id && x.deD_Id == resElementDetails.deD_Id)[0];
          if (filteredOrg) {
            filteredOrg.deD_Description = resElementDetails.deD_Description;
            filteredOrg.deD_Short_Description = resElementDetails.deD_Short_Description;
            filteredOrg.deD_CODE = resElementDetails.deD_CODE;
            filteredOrg.is_Active = resElementDetails.is_Active;
          } else {
            this.elementDetailsList = [...this.elementDetailsList, ...[resElementDetails]];
          }
        }
        this._notificationService.showToast(res.response.successMessage, "Success");
      }

      else if (res.response.successCode == 205) {
        this._notificationService.showToast(res.response.successMessage, "Warning");
      }
      else if (res.response.successCode == 500) {
        this._notificationService.showToast(res.response.successMessage, "Warning");
      }
      this.getElementDetailsList(this.elementId);
    }, err => { });
  }

  /**
   * Toggle filter
   */
  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }
  /**
   * Toggle full screen
   */
  toggleFullscreen() {
    this.enableFullscreen = !this.enableFullscreen;
  }

}
